module.exports = __webpack_public_path__ + "img/logo2.16ad646b.png";